module.exports = __webpack_public_path__ + "img/prototype_board.bd50b023.jpg";